// Default configuration constants
export const DEFAULT_CONFIG = {
  position: { bottom: '20px', right: '20px' },
  theme: {
    primary: '#204904ff',
    secondary: '#0ae745',
    background: '#ffffff',
    accent: '#d1d0d0ff',
    text: '#053d03ff',
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444'
  },
  apiKey: 'AIzaSyDpXR6y1BrBS8Bb-eNjIXGobHkNlG8D1JM',
  welcomeMessage: "Hello! I am Zico, welcome Sunshine",
  botName: "Sunshine assistant",
  placeholder: "Type your message...",
  maxHeight: "500px",
  apiBaseUrl: "https://sunshine.pythonanywhere.com"
};

// Internet packages configuration
export const INTERNET_PACKAGES = [
  { id: 'package_50', name: '2GB - 2 Days', price: 1, data: '2GB', duration: '2 days' },
  { id: 'package_100', name: '3GB - 3 Days', price: 100, data: '3GB', duration: '3 days' },
  { id: 'package_650', name: '10GB - 1 Month', price: 650, data: '10GB', duration: '1 month' }
];

// Polling configuration
export const POLLING_CONFIG = {
  maxPolls: 24, // 2 minutes with 5-second intervals
  pollInterval: 5000 // 5 seconds
};